

export const commonBase = {
  "kiui_color_base_black_1": "#000000",
  "kiui_color_base_black_1_a12": "#0000001F",
  "kiui_color_base_black_1_a24": "#0000003D",
  "kiui_color_base_black_1_a32": "#00000052",
  "kiui_color_base_black_1_a40": "#00000066",
  "kiui_color_base_black_1_a48": "#0000007A",
  "kiui_color_base_black_1_a5": "#0000000D",
  "kiui_color_base_black_1_a64": "#000000A3",
  "kiui_color_base_black_1_a88": "#000000E0",
  "kiui_color_base_black_10_a72": "#2C2C2CB8",
  "kiui_color_base_black_14": "#474747",
  "kiui_color_base_black_15": "#ADADAD",
  "kiui_color_base_black_16": "#F2F2F2",
  "kiui_color_base_black_19": "#E4E4E4",
  "kiui_color_base_black_20": "#D2D2D2",
  "kiui_color_base_black_21_a24": "#C8C8C83D",
  "kiui_color_base_black_5": "#1F1F1F",
  "kiui_color_base_black_6": "#5C5C5C",
  "kiui_color_base_black_7": "#999999",
  "kiui_color_base_black_8": "#C2C2C2",
  "kiui_color_base_black_9": "#E0E0E0",
  "kiui_color_base_blue_1_a16": "#78788029",
  "kiui_color_base_cyan_1": "#004182",
  "kiui_color_base_green_1": "#00BD5C",
  "kiui_color_base_red_1": "#FF4906",
  "kiui_color_base_red_1_a12": "#FF49061F",
  "kiui_color_base_red_1_a50": "#FF490680",
  "kiui_color_base_red_2": "#FF0000",
  "kiui_color_base_red_2_a12": "#FF00001F",
  "kiui_color_base_violet_1": "#B0AFB4",
  "kiui_color_base_white_1": "#FFFFFF",
  "kiui_color_base_white_1_a40": "#FFFFFF66",
  "kiui_color_base_white_1_a88": "#FFFFFFE0"
}

export const colorScene = {}

export const colorSceneLight = {}

export const colorSceneDark = {}
